import GitHubIcon from "@mui/icons-material/GitHub";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FaceIcon from "@mui/icons-material/Face";
import Statistic from "./statistic";
import "./layout.css";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-main">
        <div>
          <a className="footer-brand" href="/">
            enqurance.
          </a>
          <p>A trail of ideas, places, and people.</p>
        </div>
        <div className="social-links">
          <a href="https://github.com/Enqurance" aria-label="GitHub">
            <GitHubIcon />
          </a>
          <a href="mailto:lin.zijie@u.nus.edu" aria-label="Email">
            <EmailIcon />
          </a>
          <a
            href="https://www.linkedin.com/in/%E5%AD%90%E6%9D%B0-%E6%9E%97-604690296/?locale=en_US"
            aria-label="LinkedIn"
          >
            <LinkedInIcon />
          </a>
          <a href="https://enqurance.github.io/" aria-label="Previous website">
            <FaceIcon />
          </a>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Zijie Lin · Enqurance</span>
        <Statistic />
        <span>Still exploring ↗</span>
      </div>
    </footer>
  );
}
